// extracted by mini-css-extract-plugin
module.exports = {"footerLinks":"FooterLinks_footerLinks__3XRfC"};